// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"c450a0d0","437":"febf7e8e"}[chunkId] + ".chunk.css";
};